module.exports = __webpack_public_path__ + "img/particle_motion_00095.0ca4fb3d.png";